export default __webpack_public_path__ + "static/media/rooneys.1e14513f.jpg";